import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { fmtRelative } from "@/lib/format";

export const NotificationBell = () => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = () => api.get("/notifications", { params: { limit: 6 } }).then((r) => setData(r.data)).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <Popover onOpenChange={(o) => o && load()}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell-btn" className="relative grid h-10 w-10 place-items-center rounded-full border border-[#e4e8e1] bg-white hover:bg-[#F7F7F7] transition-colors">
          <Bell size={18} />
          {data.unread > 0 && (
            <span data-testid="notification-unread-count" className="absolute -right-0.5 -top-0.5 min-w-[18px] h-[18px] rounded-full bg-[#5CD500] px-1 text-[10px] font-bold text-[#0f1a08] grid place-items-center">{data.unread}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notification-popover">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <span className="font-semibold text-sm">Notificaciones</span>
          {data.unread > 0 && <button data-testid="notification-read-all-btn" onClick={readAll} className="text-xs text-[#258F00] font-semibold">Marcar todas leídas</button>}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {data.items.length === 0 && <div className="p-6 text-center text-sm text-[#5b6656]">Sin notificaciones</div>}
          {data.items.map((n) => (
            <div key={n.id} className={`px-4 py-3 border-b last:border-0 text-sm ${n.read_at ? "opacity-60" : ""}`}>
              <div>{n.message}</div>
              <div className="text-[11px] text-[#5b6656] mt-1">{fmtRelative(n.created_at)}</div>
            </div>
          ))}
        </div>
        <Link to="/notificaciones" data-testid="notification-see-all-link" className="block text-center text-xs font-semibold text-[#258F00] py-2.5 border-t">Ver todas</Link>
      </PopoverContent>
    </Popover>
  );
};
